import { FilterMatchMode } from 'primereact/api'

/**
 * Creates initial filter state from column definitions
 * Ensures each filterable column has a properly structured constraints array
 * This allows PrimeReact's addRule() to work immediately on page load
 * 
 * @param {Array} columnDefinitions - Column definitions array
 * @returns {Object} Initial filter state with constraints for each filterable column
 */
export const createInitialFilterState = (columnDefinitions) => {
    if (!columnDefinitions || !Array.isArray(columnDefinitions) || columnDefinitions.length === 0) {
        return null
    }

    const initialFilters = {}

    columnDefinitions.forEach(col => {
        // Only create filter state for columns that have filtering enabled
        if (col.filter) {
            initialFilters[col.mapsToField] = {
                operator: 'and',  // Default operator
                constraints: [
                    {
                        value: null,
                        matchMode: col.filterMatchMode || FilterMatchMode.CONTAINS
                    }
                ]
            }
        }
    })

    // Return null if no filterable columns found
    return Object.keys(initialFilters).length > 0 ? initialFilters : null
}
